import { PaginationProps } from 'rc-pagination';
import styled from 'styled-components';

interface BidAreaStyleProps {
  hasAlerts: boolean;
}

export const BidPanelStyle = styled.div`
  background: ${(prop)=>prop.theme.background.surface};
  top: 0;
  padding: 1rem;
  z-index: 0;
  position: absolute;
  height: 100vh;
  width: 33rem;
  display: flex;
  flex-direction: column;
  right: 0;
  overflow: hidden;

  #bidsVoidButton {
    background: #FCD839;
    color: black;
    padding: 0 5px;
  }

  borderradius: 4px;
  border: ${({ theme }) => theme.border.medium};
  fontfamily: "Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif;
  fontsize: 0.75rem;

  /*to hide vertical scrollbar in the grid*/
  .ag-body-viewport::-webkit-scrollbar {
    display: none !important;
  }

  .ag-body-viewport-wrapper.ag-layout-normal {
    overflow-x: none !important;
  }

  .shell-button {
    border: 1px solid #383c41;
    min-height:35px;
  }
   .shell-button span {  
    font-size:12px;
  }
  input {
    height: 35px;
    background-color: ${({ theme }) => theme.background.surface};
    border: 1px solid #313439 !important;
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.text.onPrimary};
    
    &::placeholder {
      color: ${({ theme }) => theme.text.onSecondary};
      opacity: 1;
    }

    &:focus {
      border-color: ${({ theme }) => theme.border.medium};
      outline: none;
    }
  }

  #applyLabel {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }

  #confirmButton{
    border-radius:2px;
    padding:0px 10px;
    min-height:35px;
  }

  #confirmButton span{
    font-size:12px;
  }
  #confirmButton:disabled {
    opacity:0.32;
    color:white;
  }

  #applyButton{
    box-sizing:border-box;
    border-radius:2px;
    padding:0px 5px;
    width:50%;
    min-height:10px !important;
  }

  #applyButton span{
    font-size:12px;
  }
  #applyButton:disabled {
    opacity:0.32;
    color:white;
  }
  

  #addQtyAndPriceButton{
    border-radius:2px;
    padding:0px 10px;
  }

  #addQtyAndPriceButton span{
    font-size:12px;
  }
  #addQtyAndPriceButton:disabled {
    opacity:0.32;
    color:white;
  }

  #deleteButton {
    border-radius:2px;
    padding:0px 10px;
    width: 120px;
  }
  #deleteButton span{
    font-size:12px;
  }
  #deleteButton:disabled {
    opacity:0.32;
    color:white;
  }
  #deleteButton:disabled span svg path {
    fill:white;
  }

  #voidButton {
    border-radius:2px;
    padding:0px 10px;
  }
  #voidButton span{
    font-size:12px;
  }
  #voidButton:disabled {
    opacity:0.32;
    color:white;
  }
  #voidButton:disabled span svg path {
    fill:white;
  }

  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid gray;
    margin: 0 -50px;
    padding: 0;
}

  .rightalign {
    float: right;
    margin-right: 10px;
    border-radius:2px;
    padding:0px 5px;
    font-size:12px;
    margin-top:-6px;
  }

  .bottom-controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    margin-top: auto; // Push to bottom
  }

  .quantity-price-label {
    margin: 0;
    padding: 0;
  }

  button[id="historyBiddingButton"] {
    min-width: 180px; // Increased to accommodate text and padding
    padding: 0.75rem 1.5rem 0.75rem 2.5rem; // More padding, extra on left for icon
    white-space: nowrap;
    position: relative; // For icon positioning
    
    svg {
      position: absolute;
      left: 1rem;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .quantity-price-container {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 10px 0;
    margin-bottom: 1rem;
  }
`;

export const PaginationStyle = styled.div<PaginationProps>`
.pagination {
  margin-top: 5px;
  margin-bottom: 10px;
  decoration: underline;
}
.rc-pagination-prev button:after {
  margin-bottom: 2rem;
}
.rc-pagination-prev .rc-pagination-item-link {
  padding-top: 0.35rem;
}

.rc-pagination-prev .rc-pagination-item-link,
.rc-pagination-item-disabled,
.rc-pagination-next,
.rc-pagination-item-link,
.rc-pagination-prev {
  background-color: #212429 !important;
  color: #7f7f7f !important;
}

.rc-pagination-item-active {
  border-color: #fcd839 !important;
  font-weight: bold;
}
`;

export const PaginationPageStyle = styled.div<{status: string}>`
 a {
  background-color: ${({status}) =>
    status === 'Draft' ? '#FCD839':
    status === 'Accepted' ? 'green':
    status === 'Amended' ? 'orange':
    status === 'Rejected' ? '#EB777A': '#212429'} !important;
  color: ${({status}) => (status === 'Draft' || status === 'Amended')
    ? '#090909 !important'
    : '#d9d9d9 !important'};
}
`;

export const BidHeaderModal = styled.div`
  background: #212429;
  display: flex;
  height: 4rem;
  padding-left: 1rem;
  margin-top: -0.5rem;
  padding-top: 0.5rem;
  column-gap: 1rem;
  flex-wrap: wrap;
  .crossIcon {
    margin-left:auto;
    cursor: pointer;
    height:25px;
    width:25px;
  }
  #corridorHeader {
    margin-top: 0.2rem;
    flex-basis: 100%;
  }
`;

export const BidBodyModal = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 150px);
  min-height: 0;
  padding: 0;

  #maintenanceMessage,
  #alertMessage,
  #bookMessage {
    width: calc(100% - 1rem);
    margin: 0 0 10px 0;
    background: ${(prop)=>prop.theme.background.surface};
    line-height: 1.5;
  }

  #gridArea {
    flex: 1;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 0 1rem;
  }

  #quantityAndPriceLabel {
    margin-top: 0.5rem;
    position: sticky;
    bottom: 0;
    background: ${(prop)=>prop.theme.background.surface};
    z-index: 1;
    padding-bottom: 0.5rem;
  }

  .alert-container {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  .alert {
    width: 100%;
    max-width: none;
  }
`;

export const BidFooterModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
  background: ${(prop)=>prop.theme.background.surface};

  .footer-left {
    display: flex;
    align-items: left;
    gap: 0.5rem;
  }

  #bidHistoryButton {
    min-width: 180px;
    padding: 0.5rem 0.5rem;
    white-space: nowrap;
    border: none;
    
    svg {
      margin-right: 0.5;
    }
  }

  #bidSubmitButton {
    min-width: 120px;
    padding: 0.5rem ;
    white-space: nowrap;
    margin-left: 1rem;
  }
`;

export const BidAreaStyle = styled.div<BidAreaStyleProps>`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  width: 100%;
`;

export const BidGridStyle = styled.div<{ alertCount: number, maintenanceMessagesCount: number }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  height: ${props => {
    const baseHeight = 'calc(100vh - 410px)';
    const alertHeight = props.alertCount > 0 ? props.alertCount * 60 : 0;
    const maintenanceHeight = props.maintenanceMessagesCount > 0 ? 20 + props.maintenanceMessagesCount * 35 : 0;
    const reducedHeight = alertHeight + maintenanceHeight;
    return (props.alertCount + props.maintenanceMessagesCount) > 0 ? `calc(${baseHeight} - ${reducedHeight}px)` : baseHeight;
  }};
  
  .ag-root-wrapper {
    border: none;
    height: 100%;
  }
`;

export const QuantityAndPriceApplyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const QuantityAndPriceApplyLabelStyle = styled.div`
  display: flex;
  gap: 1rem;

  // Style for each label-input group
  > div {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    width: 185px; // Match input width
  }

  label {
    color: ${({ theme }) => theme.text.onPrimary};
    font-size: 14px;
  }
`;

export const QuantityAndPriceApplyEntryStyle = styled.div`
  display: flex;
  gap: 1rem;
  padding: 10px 0;

  input {
    width: 150px;
    height: 35px;
    background-color: ${({ theme }) => theme.background.surface};
    border: 1px solid #313439 !important;
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
  }
`;

export const BookContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  #bookId {
    margin-top: 0.5rem;
  }

  #updateBookButton {
    background: #313439;
    color: white;
  }

  column-gap: 1rem;
  margin-bottom: 0.7rem;
  color: white;
`;

export const BidPaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;

  .pagination-numbers {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .delete-all-button {
    margin-left: auto; // This will push the button to the right
  }
`;

export const BidInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0.5rem 0;

  // Title styling
  > h3 {
    color: ${({ theme }) => theme.text.onPrimary};
    font-size: 14px;
    margin: 0;
    padding: 0;
  }
`;

export const InputGroupContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;

  // Each input group (label + input)
  .input-group {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    label {
      color: ${({ theme }) => theme.text.onPrimary};
      font-size: 14px;
    }

    input {
      width: 150px;
      height: 35px;
      background-color: ${({ theme }) => theme.background.surface};
      border: 1px solid #313439 !important;
      border-radius: 4px;
      padding: 0 10px;
      box-sizing: border-box;

      /* Hide spinner buttons for Webkit browsers (Chrome, Safari, Edge) */
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Hide spinner buttons for Firefox */
      &[type='number'] {
        -moz-appearance: textfield;
      }
    }
  }

  .sede-enterprise-text-input {
    input {
      /* Hide spinner buttons for Webkit browsers (Chrome, Safari, Edge) */
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Hide spinner buttons for Firefox */
      &[type='number'] {
        -moz-appearance: textfield;
      }
    }

    // Preserve the info icon styling
    .info-icon {
      display: flex;
      align-items: center;
    }
  }
`;
